const ja = {
  // Navigation
  "nav.top": "TOP",
  "nav.service": "サービス内容",
  "nav.system": "システムについて",
  "nav.flow": "導入の流れ",
  "nav.about": "会社概要",
  "nav.contact": "お問い合わせ",
  "nav.privacy": "プライバシーポリシー",

  // Hero
  "hero.catchcopy": "銀行振込の管理を、もっと正確に、もっとシンプルに。",
  "hero.sub": "決済管理・資金管理業務の支援とシステム開発により、業務の効率化と高度化を実現します。",
  "hero.cta": "サービスを見る",
  "hero.cta2": "お問い合わせ",

  // TOP sections
  "top.about.label": "ABOUT US",
  "top.about.title": "Stream Solutions Limitedとは",
  "top.about.desc": "当社は、日本国内における銀行振込を中心とした決済管理および資金管理業務の支援を行うとともに、これらを効率化するためのシステム開発・提供を行っております。業務フロー全体を最適化するため、単なる業務代行にとどまらず、自社開発によるシステムを活用し、データ連携・自動化・可視化までを一体的に設計・提供しております。",
  "top.about.btn": "会社概要を見る",

  "top.services.label": "OUR SERVICES",
  "top.services.title": "提供サービス",
  "top.services.sub": "決済管理から自動化システムまで、ワンストップで提供します。",

  "top.service1.title": "入金管理",
  "top.service1.desc": "入金情報の取得・管理を正確かつリアルタイムに行います。",
  "top.service2.title": "消込処理",
  "top.service2.desc": "振込データとの照合・消込処理を自動化し、ミスを排除します。",
  "top.service3.title": "資金精算支援",
  "top.service3.desc": "資金の整理および精算業務を効率的にサポートします。",
  "top.service4.title": "レポーティング",
  "top.service4.desc": "各種レポーティングおよびデータ分析を提供します。",
  "top.service5.title": "自動化システム",
  "top.service5.desc": "決済・経理業務の自動化システムを開発・提供します。",
  "top.service6.title": "データ可視化",
  "top.service6.desc": "業務データをリアルタイムで可視化し、意思決定を支援します。",

  "top.system.label": "SYSTEM",
  "top.system.title": "自社開発システム",
  "top.system.desc": "データ連携・自動化・可視化を一体的に設計した独自プラットフォームで、業務の高度化を実現します。",
  "top.system.btn": "詳しく見る",

  "top.cta.title": "まずはお気軽にご相談ください",
  "top.cta.sub": "業務課題のヒアリングから最適なソリューションのご提案まで、専門チームが対応いたします。",
  "top.cta.btn": "お問い合わせ",

  "top.stats.clients": "導入企業数",
  "top.stats.accuracy": "照合精度",
  "top.stats.support": "サポート対応",
  "top.stats.years": "業界経験",

  // Service page
  "service.hero.title": "サービス内容",
  "service.hero.sub": "決済管理・資金管理業務の支援から自動化システムの開発まで、一体的に提供します。",
  "service.s1.title": "入金情報の取得および管理",
  "service.s1.desc": "銀行口座への入金情報をリアルタイムで取得・管理します。複数口座の一元管理により、入金状況を常に正確に把握できます。",
  "service.s2.title": "振込データとの照合（消込処理）",
  "service.s2.desc": "請求データと入金データを自動照合し、消込処理を効率化します。手作業によるミスを排除し、処理速度を大幅に向上させます。",
  "service.s3.title": "資金の整理および精算支援",
  "service.s3.desc": "資金フローの整理・精算業務を包括的にサポートします。複雑な資金管理をシンプルかつ正確に処理します。",
  "service.s4.title": "各種レポーティングおよび分析",
  "service.s4.desc": "業務データを多角的に分析し、経営判断に役立つレポートを提供します。カスタマイズ可能なダッシュボードで情報を可視化します。",
  "service.s5.title": "決済・経理業務の自動化システム",
  "service.s5.desc": "自社開発の自動化システムにより、決済・経理業務の工数を大幅に削減します。人的ミスの排除と業務効率化を同時に実現します。",
  "service.flow.title": "サービス提供の流れ",
  "service.flow.sub": "ヒアリングから運用開始まで、専任チームが丁寧にサポートします。",

  // System page
  "system.hero.title": "システムについて",
  "system.hero.sub": "自社開発プラットフォームで、データ連携・自動化・可視化を一体的に実現します。",
  "system.feature1.title": "リアルタイムデータ連携",
  "system.feature1.desc": "銀行APIとのリアルタイム連携により、入金情報を即時取得・反映します。",
  "system.feature2.title": "AI自動照合エンジン",
  "system.feature2.desc": "機械学習を活用した高精度な自動照合エンジンで、消込処理を完全自動化します。",
  "system.feature3.title": "セキュアなクラウド基盤",
  "system.feature3.desc": "金融グレードのセキュリティ基準に準拠したクラウドインフラで、データを安全に管理します。",
  "system.feature4.title": "カスタマイズ可能なダッシュボード",
  "system.feature4.desc": "業務ニーズに合わせてカスタマイズ可能なダッシュボードで、KPIをリアルタイムに可視化します。",
  "system.feature5.title": "API連携・外部システム統合",
  "system.feature5.desc": "既存の会計システムやERPとのAPI連携により、シームレスなデータ統合を実現します。",
  "system.feature6.title": "自動レポート生成",
  "system.feature6.desc": "定期レポートの自動生成・配信機能により、報告業務の工数をゼロに近づけます。",
  "system.tech.title": "技術スタック",
  "system.tech.sub": "最新のテクノロジーを活用した、スケーラブルで信頼性の高いシステムを構築しています。",
  "system.cta.title": "システムのデモをご覧ください",
  "system.cta.sub": "実際のシステム画面をご覧いただきながら、導入効果をご確認いただけます。",
  "system.cta.btn": "デモを申し込む",

  // Footer
  "footer.company": "Stream Solutions Limited",
  "footer.address.en": "Room D, Rm4. 2/F, Sunray Industrial Centre, 610 Cha Kwo Ling Road, Yau Tong, KL.",
  "footer.address.ja": "香港九龍油塘茶果嶺道610號 生利工業大廈2樓4室",
  "footer.tel": "+852-5321-3455",
  "footer.nav": "ナビゲーション",
  "footer.contact_info": "お問い合わせ",
  "footer.copyright": "© 2024 Stream Solutions Limited. All rights reserved.",
  "footer.privacy": "プライバシーポリシー",
  "footer.tagline": "銀行振込の管理を、もっと正確に、もっとシンプルに。",
};

export default ja;
